<template>
  <v-snackbar v-model="display" color="error" :timeout="10000">
    <v-alert type="error">
      <div>{{ message }}</div>
    </v-alert>
    <template v-slot:actions>
      <v-btn icon theme="dark" v-bind="$attrs" @click="onPushCloseBtn">
        <v-icon>close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

/** Refs **/
const display = ref(false);
const message = ref('');

/** Methods **/
const open = (obj: { message: string }): void => {
  message.value = obj.message;
  display.value = true;
};

const close = (): void => {
  display.value = false;
};

const onPushCloseBtn = (): void => {
  close();
};

defineExpose({ open });
</script>
